<div class="row" id="gallery">

    <div class="column">
        <div class="maintxt" *ngFor="let image of gallery_col1 | async ; let i = index">
            <a routerLink="{{'/sthan/'+image.sthanEnglish}}">
                <img src="{{'../assets/'+image.path}}" style="width:100%">
                <div style="border: 1px solid #ccc; text-align: center;" class="overlay-text marathi-font">
                    {{image.sthan}}</div>
            </a>
        </div>
    </div>
    <div class="column">
        <div class="maintxt" *ngFor="let image of gallery_col2 | async ; let i = index">
            <a routerLink="{{'/sthan/'+image.sthanEnglish}}">
                <img src="{{'../assets/'+image.path}}" style="width:100%">
                <div style="border: 1px solid #ccc; text-align: center;" class="overlay-text marathi-font">
                    {{image.sthan}}</div>
            </a>
        </div>
    </div>
    <div class="column">
        <div class="maintxt" *ngFor="let image of gallery_col3 | async ; let i = index">
            <a routerLink="{{'/sthan/'+image.sthanEnglish}}">
                <img src="{{'../assets/'+image.path}}" style="width:100%">
                <div style="border: 1px solid #ccc; text-align: center;" class="overlay-text marathi-font">
                    {{image.sthan}}</div>
            </a>
        </div>

    </div>
    <div class="column">
        <div class="maintxt" *ngFor="let image of gallery_col4 | async ; let i = index">
            <a routerLink="{{'/sthan/'+image.sthanEnglish}}">
                <img src="{{'../assets/'+image.path}}" style="width:100%">
                <div style="border: 1px solid #ccc; text-align: center;" class="overlay-text marathi-font">
                    {{image.sthan}}</div>
            </a>
        </div>

    </div>

</div>
